"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeolocationChannel = void 0;
const action_1 = require("../../action");
const topic_1 = require("../../topic");
const GEOLOCATION_CHANNEL = 'geolocation';
class GeolocationChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = GEOLOCATION_CHANNEL;
        this.topics = {
            initGeolocationFlow: new topic_1.Topic('initGeolocationFlow', this.channel, this._logger),
            geolocationInProgress: new topic_1.Topic('geolocationInProgress', this.channel, this._logger),
            geolocationRestrictionUpdate: new topic_1.Topic('geolocationRestrictionUpdate', this.channel, this._logger),
            geolocationStatus: new topic_1.Topic('geolocationStatus', this.channel, this._logger),
            userInitiatedRetry: new topic_1.Topic('userInitiatedRetry', this.channel, this._logger),
            initialize: new action_1.Action('initialize', this.channel, this._logger),
            getStatusRequest: new action_1.Action('getStatusRequest', this.channel, this._logger)
        };
    }
}
exports.GeolocationChannel = GeolocationChannel;
//# sourceMappingURL=geolocation.channel.js.map